import { api, type Query } from './client'

/**
 * Liste cevabını diziye açar. BE zarfları: `[]`, `{items, meta}`, `{data}` ya da modül adlı tek dizi
 * (`{employees}`, `{departments}`, `{projects}` …). Öncelik items → data → nesnedeki ilk dizi alan.
 */
export function asList<T>(data: T[] | { items?: T[]; data?: T[] } | null | undefined): T[] {
  return unwrap(data) as T[]
}

/** Tipsiz cevaplar için: satırları `Record` olarak döner (nesne olmayan elemanlar boş kayda dönüşür). */
export function asRows(data: unknown): Record<string, unknown>[] {
  return unwrap(data).map((v) => (v && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : {}))
}

function unwrap(data: unknown): unknown[] {
  if (Array.isArray(data)) return data
  if (!data || typeof data !== 'object') return []
  const env = data as Record<string, unknown>
  if (Array.isArray(env.items)) return env.items
  if (Array.isArray(env.data)) return env.data
  for (const value of Object.values(env)) if (Array.isArray(value)) return value
  return []
}

/** Sayfalı zarfın toplam kaydı: `meta.total_items` (platform standardı) veya eski `total_count/total`. */
export function pageTotal(data: unknown, fallback = 0): number {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return fallback
  const row = data as Record<string, unknown>
  const meta = row.meta && typeof row.meta === 'object' ? (row.meta as Record<string, unknown>) : null
  const candidates = [meta?.total_items, row.total_count, row.totalCount, row.total, row.count]
  for (const value of candidates) {
    if (typeof value === 'number' && Number.isFinite(value)) return value
    if (typeof value === 'string' && value.trim() && !Number.isNaN(Number(value))) return Number(value)
  }
  return fallback
}

/**
 * Sayfalı BE uçlarından tam listeyi tek istekte alır (`all=true`; BE tavanı 5000).
 * Lookup/seçici ve istemci tarafı sayfalanan tablolar için standart yol.
 */
export async function fetchAll<T = unknown>(path: string, query?: Query): Promise<T[]> {
  return unwrap(await api.get<unknown>(path, { ...query, all: true })) as T[]
}
